import { InjectionToken } from '@angular/core';
import { TelemetryInitializer } from './models';

export const TELEMETRY_INITIALIZER = new InjectionToken<TelemetryInitializer>('AppInsights Telemetry Initializer');
